const WORDS = ["Vidya", "•", "Bhakti", "•", "Sanskaar", "•", "Gyaan", "•", "Seva", "•", "Vinay", "•"];

export const Marquee = () => (
  <section data-testid="marquee-section" className="bg-maroon py-8 border-y border-saffron/25 overflow-hidden">
    <div className="marquee-track">
      {[0, 1].map((k) => (
        <div key={k} className="flex items-center" aria-hidden={k === 1}>
          {WORDS.map((w, i) => (
            <span
              key={`${k}-${i}`}
              className={`ff-display text-4xl md:text-6xl px-6 md:px-10 ${
                w === "•" ? "text-saffron" : "text-cream italic"
              }`}
            >
              {w}
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
